import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  summary: string;
  category: string;
  categoryName: string;
  date: string;
  readTime: number;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  summary,
  category,
  categoryName,
  date,
  readTime,
  imageUrl,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-background-300/60 transition-colors duration-300">
      <Link to={`/article/${id}`} className="no-underline">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${category}`}
              className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full whitespace-nowrap no-underline"
            >
              {categoryName}
            </Link>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${id}`} className="no-underline">
          <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs text-foreground-500">{date}</span>
          <span className="text-xs text-foreground-500">{readTime} 分钟阅读</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}